import React from 'react';
import { useSelector } from 'react-redux';
import i18n from 'i18next';
import qs from 'query-string';

import DialogSystem from 'client/components/DialogSystem';

export default function DialogEnterpriseBindLine({ open, onClose = () => {} }) {
    const { notQualifiedErrInfo: { redirectUrl = '' } = {} } = useSelector(s => s.userLoginState);

    return (
        <DialogSystem
            isOpen={open}
            title={i18n.t('label.no_qualify_join')}
            body={
                redirectUrl
                    ? i18n.t('desc.sorry_no_qualify.member_bind')
                    : i18n.t('desc.sorry_no_qualify.member_bind_outdated')
            }
            endButton={redirectUrl ? i18n.t('btn.goto_bind') : null}
            closePopup={() => {
                const { query, url } = qs.parseUrl(redirectUrl);
                const qStr = qs.stringify({ ...query, redirect_uri: window.location.href });
                window.open(`${url}?${qStr}`);
                onClose();
            }}
        />
    );
}
